import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toTree',
    standalone: true
})
export class ToTreePipe implements PipeTransform {

  transform(value: number): number {
    return Math.ceil((value / 1000) / 100);
  }

}
